<template>
  <div class="body">
    <div id="game"></div> 
    <h1 class="score">分数：{{ score }}</h1>
    <van-popup v-model="showStart" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <h1 class="logo">
          齐天大圣 <br />
          孙悟空
        </h1>
        <br />
        <van-tag v-if="play_times_free>play_times_today" type="success" size="large">今日免费次数： {{play_times_today}} / {{play_times_free}}</van-tag>
        <br /><br />
        <ul>
          <li v-if="play_times_free<=play_times_today">{{ price }} 金豆游戏一次</li>
          <li>成功前进一步 分数 +{{ gameConf.jumpAdd }}</li>
          <li>孙悟空前进时，点击屏幕,可以切换方向</li>
          <li>获得一枚金币 分数 +{{ gameConf.coinAdd }}</li>
          <li>孙悟空掉落或撞到障碍物，游戏结束</li>
          <li>结束后, 所有分数结算为金豆</li>
        </ul>
        <br />
        <h1>当前金豆: {{ user_score }}</h1>
        <br /><br />
        <van-button
          type="danger"
          plain
          @click="gameStart()"
          :loading="progress < 1"
          :loading-text="parseInt(progress * 100) + ' %'"
          :disabled ="play_times_today>=play_times_max"
        >
          开始游戏 {{play_times_today}}/{{play_times_max}}
        </van-button>
        <br /><br />
        <!-- <van-button type="info" plain @click="quit()"> 退出 </van-button> -->
      </div>
    </van-popup>
    <van-popup v-model="showEndTip" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <br /><br /><br />
        <h1 class="logo">游戏结束</h1>
        <br /><br /><br />
        <h2>结算中,请稍后...</h2>
      </div>
    </van-popup>
    <van-popup v-model="showEnd" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <h1 class="logo">
          齐天大圣 <br />
          孙悟空
        </h1>
        <br /><br /><br />
        <div class="endInfo">
          
          <br />
        <van-tag v-if="play_times_free>play_times_today" type="success" size="large">今日免费次数： {{play_times_today}} / {{play_times_free}}</van-tag>
        <br /><br />
          <h2>获得金豆: {{ score }}</h2>
        </div>

        <br />
        <h1>当前金豆: {{ user_score }}</h1>
        <br /><br />
        <van-button type="danger" plain @click="gameStart()"
        :disabled ="play_times_today>=play_times_max"
          >重新开始 {{play_times_today}}/{{play_times_max}}</van-button
        >
        <br /><br />
        <van-button
          type="primary"
          plain
          @click="
            showEnd = false;
            showStart = true;
          "
          >查看规则</van-button
        >
        <br /><br />
        <!-- <van-button type="info" plain @click="quit()">退出</van-button> -->
      </div>
    </van-popup>
  </div>
</template>
<style scoped>
.panel {
  padding: 2rem 0.5rem;
  /* background-color:white; */
  text-align: center;
}
.van-popup {
  background-color: #00000000;
  color: white;
}
.panel .logo {
  font-size: 0.8rem;
  color: tomato;
}
.score {
  font-size: 0.5rem;
  color: #ffffff;
  position: fixed;
  top: 65px;
  right: 30px;
}
.body{
  background-color: #0c88c7 !important;
  height: 100%;
}
</style>
<script>
import Vue from "vue";
import { Popup } from "vant";
import { Button } from "vant";
import { Col, Row } from "vant";
import { Toast } from "vant";
Vue.use(Col);
Vue.use(Row);
Vue.use(Button);
Vue.use(Popup);

import { Tag } from 'vant';
Vue.use(Tag);

import { VUE_GAME_ASSETS_URL } from "@utils";
import { getUserInfo,getUserInfo_game } from "@api/user";
import { game9_config, game9_start, game9_end } from "@api/game";

// import { playGame } from "@utils/games/game9_tyt";
import Phaser from "phaser";
export default {
  name: "Game9_tyt",
  data() {
    return {
      user_id: 0,
      user_score: 0,
      log_id: 0,
      showStart: true,
      showEnd: false,
      showEndTip: false,
      gameMode: IDLE,

      price: 0,
      gameConf: {
        jumpAdd: 5,
        coinAdd: 5,
      },
      play_times_today:10,
      play_times_max:10,
      play_times_free:0,
      score: 0,
    };
  },
  mounted: function () {
    this.user_id=this.getQueryVariable('uid')
    vm = this;
    let that = this;
    // getUserInfo_game(this.user_id).then(res => {
      game9_config({ user_id: that.user_id }).then((res) => {
        console.log(res);
        that.user_score = parseFloat(res.data.user_score);
        that.price = res.data.price;
        that.gameConf = res.data.gameConf;
        that.play_times_today = res.data.play_times_today;
        that.play_times_free = res.data.play_times_free?res.data.play_times_free:0;
      });
    // });
    onload();
  },
  methods: {
    getQueryVariable(variable)
    {
          var query = window.location.href.substring(window.location.href.indexOf('?')+1);
          var vars = query.split("&");
          for (var i=0;i<vars.length;i++) {
                  var pair = vars[i].split("=");
                  if(pair[0] == variable){return pair[1];}
          }
          return(false);
    },
    gameStart() {
      if (this.play_times_free<=this.play_times_today && this.user_score<this.price) {
        Toast.fail('金豆不足');
        return;
      }
      let that = this;
      game9_start({ user_id: that.user_id })
        .then((res) => {
          console.log(res);
          // that.user_score -= that.price;
          that.showStart = false;
          that.showEnd = false;
          that.user_score = parseFloat(res.data.game_money);
          that.log_id = res.data.log_id;
          that.score = 0;
          that.play_times_today++;
        })
        .catch((err) => {
          Toast.fail(err.msg);
        });
      
    },
    gameEnd() {
      let that = this;
      that.showEndTip = true;
      setTimeout(function () {
        that.showEnd = true;
        that.showEndTip = false;
        game9_end({
          user_id: that.user_id,
          score: that.score,
          log_id: that.log_id,
        }).then(() => {});
        that.user_score += that.score;
      }, 1000);
    },
    addJumpScore() {
      this.score += this.gameConf.jumpAdd;
    },
    addCoinScore() {
      this.score += this.gameConf.coinAdd;
    },
    quit() {
      this.$router.push({ path: "/user" });
    },
  },
  beforeDestroy: function () {
    if (game) {
      game.destroy();
    }
    let canvas = document.getElementsByTagName("canvas");
    if (canvas[0]) canvas[0].remove();
  },
};
let vm;
let game;
let gameOptions = {
  platformGapRange: [200, 400], //右侧平台生成位置范围
  platformWidthRange: [50, 150], //右侧平台生成宽度范围
  platformHeight: 600, //平台高度
  playerWidth: 32, //玩家宽度
  playerHeight: 64, //玩家高度
  poleWidth: 8, //杆的宽度
  growTime: 500, //生长时间
  rotateTime: 500, //落杆时间
  walkTime: 3, //行走时间
  fallTime: 500, //掉落时间
  scrollTime: 250, //滚动时间
};
const IDLE = 0; //空闲
const WAITING = 1; //等待
const GROWING = 2; //升长
const WALKING = 3; //移动

let bgm,coin,die;
let onload = function () {
  let gameConfig = {
    type: Phaser.AUTO,
    width: 750,
    height: 1334,
    scene: [playGame],
    transparent: true,
    parent: "game",
    // backgroundColor: 0x0c88c7,
  };
  game = new Phaser.Game(gameConfig);
  window.focus();
  resize();
  window.addEventListener("resize", resize, false);
};
class playGame extends Phaser.Scene {
  constructor() {
    super("PlayGame");
  }
  preload() {
    this.load.setBaseURL(VUE_GAME_ASSETS_URL);
    this.load.image("tile", "games/game9/tile.png");
    this.load.image("coin", "games/game9/coin.png");
    this.load.image("player", "games/game9/player.png");
    this.load.audio("bg", "games/game9/bg.mp3");
    this.load.audio("die", "games/game9/die.mp3");
    this.load.audio("coin", "games/game9/coin.mp3");
  }
  create() {
    if(!bgm){
      bgm=this.sound.add("bg");
      bgm.addMarker({
          name: 'loop',
          config: {
              loop: true
          }
      });
      bgm.play('loop');
    }
    // coin = this.sound.add("coin");
    // die = this.sound.add("die");
    this.add.sprite(100, 300, "coin");
    this.addCoin();
    this.addPlatforms();
    this.addPlayer();
    this.addPole();
    this.input.on("pointerdown", this.grow, this);
    this.input.on("pointerup", this.stop, this);
  }
  //生成两个平台
  addPlatforms() {
    this.mainPlatform = 0;
    this.platforms = [];
    this.platforms.push(this.addPlatform(0)); //在最左侧添加一个平台
    this.platforms.push(this.addPlatform(game.config.width));
    this.tweenPlatform(); //移动平台,就位
  }
  addPlatform(posX) {
    let platform = this.add.sprite(
      posX,
      game.config.height - gameOptions.platformHeight,
      "tile"
    );
    platform.displayWidth =
      (gameOptions.platformWidthRange[0] + gameOptions.platformWidthRange[1]) /
      2;
    // platform.displayHeight = gameOptions.platformHeight;
    platform.alpha = 0.7;
    platform.setOrigin(0, 0);
    return platform;
  }
  //生成钱币
  addCoin() {
    this.coin = this.add.sprite(
      0,
      game.config.height -
        gameOptions.platformHeight +
        gameOptions.playerHeight / 2,
      "coin"
    );
    this.coin.visible = false;
  }
  //放置钱币
  placeCoin() {
    this.coin.x = Phaser.Math.Between(
      this.platforms[this.mainPlatform].getBounds().right + 10,
      this.platforms[1 - this.mainPlatform].getBounds().left - 10
    );
    this.coin.visible = true;
  }
  //平台动画
  tweenPlatform() {
    //主平台宽度,  加副平台位置范围
    let destination =
      this.platforms[this.mainPlatform].displayWidth +
      Phaser.Math.Between(
        gameOptions.platformGapRange[0],
        gameOptions.platformGapRange[1]
      );
    //
    let size = Phaser.Math.Between(
      gameOptions.platformWidthRange[0],
      gameOptions.platformWidthRange[1]
    );
    this.tweens.add({
      targets: [this.platforms[1 - this.mainPlatform]], //移动目标是副平台
      x: destination, //X轴的移动终点位置
      displayWidth: size, //宽度调整
      duration: gameOptions.scrollTime, //动画时间
      callbackScope: this,
      onComplete: function () {
        vm.gameMode = WAITING; //设置等待状态
        this.placeCoin(); //放置金币
      },
    });
  }
  //添加玩家
  addPlayer() {
    this.player = this.add.sprite(
      this.platforms[this.mainPlatform].displayWidth - gameOptions.poleWidth,
      game.config.height - gameOptions.platformHeight,
      "player"
    );
    this.player.setOrigin(1, 1);
  }
  //添加击杆
  addPole() {
    this.pole = this.add.sprite(
      this.platforms[this.mainPlatform].displayWidth,
      game.config.height - gameOptions.platformHeight,
      "tile"
    );
    this.pole.setOrigin(1, 1);
    this.pole.displayWidth = gameOptions.poleWidth;
    this.pole.displayHeight = gameOptions.playerHeight / 4;
  }
  //变长
  grow() {
    if (vm.gameMode == WAITING) {
      //等待状态
      vm.gameMode = GROWING; //设置状态为变长中
      this.growTween = this.tweens.add({
        targets: [this.pole],
        displayHeight:
          gameOptions.platformGapRange[1] + gameOptions.platformWidthRange[1],
        duration: gameOptions.growTime,
      });
    } else if (vm.gameMode == WALKING) {
      //移动状态
      //切换正反状态
      if (this.player.flipY) {
        this.player.flipY = false;
        this.player.y = game.config.height - gameOptions.platformHeight;
      } else {
        this.player.flipY = true;
        this.player.y =
          game.config.height -
          gameOptions.platformHeight +
          gameOptions.playerHeight -
          gameOptions.poleWidth;
        let playerBound = this.player.getBounds();
        let platformBound = this.platforms[1 - this.mainPlatform].getBounds();
        if (
          Phaser.Geom.Rectangle.Intersection(playerBound, platformBound)
            .width != 0
        ) {
          this.player.flipY = false;
          this.player.y = game.config.height - gameOptions.platformHeight;
        }
      }
    }
  }
  //停止
  stop() {
    if (vm.gameMode == GROWING) {
      //检查状态
      vm.gameMode = IDLE; //设置状态为空闲
      this.growTween.stop(); //停止生长
      if (
        this.pole.displayHeight >
        this.platforms[1 - this.mainPlatform].x - this.pole.x
      ) {
        //如果杆的长度大于平台之间的距离
        //杆下落
        this.tweens.add({
          targets: [this.pole],
          angle: 90,
          duration: gameOptions.rotateTime,
          ease: "Bounce.easeOut",
          callbackScope: this,
          onComplete: function () {
            //下来完成,切换状态到  移动
            vm.gameMode = WALKING;
            if (
              this.pole.displayHeight <
              this.platforms[1 - this.mainPlatform].x +
                this.platforms[1 - this.mainPlatform].displayWidth -
                this.pole.x
            ) {
              //杆落在平台上
              this.walkTween = this.tweens.add({
                //开始移动
                targets: [this.player],
                x:
                  this.platforms[1 - this.mainPlatform].x +
                  this.platforms[1 - this.mainPlatform].displayWidth -
                  this.pole.displayWidth,
                duration: gameOptions.walkTime * this.pole.displayHeight,
                callbackScope: this,
                onComplete: function () {
                  //移动完成
                  this.coin.visible = false; //隐藏金币
                  //整体往左平移
                  this.tweens.add({
                    targets: [
                      this.player,
                      this.pole,
                      this.platforms[1 - this.mainPlatform],
                      this.platforms[this.mainPlatform],
                    ],
                    props: {
                      x: {
                        value: "-= " + this.platforms[1 - this.mainPlatform].x,
                      },
                    },
                    duration: gameOptions.scrollTime,
                    callbackScope: this,
                    onComplete: function () {
                      vm.addJumpScore();
                      //开始下一回合
                      this.prepareNextMove();
                    },
                  });
                },
              });
            } else {
              //杆太长
              this.platformTooLong();
            }
          },
        });
      } else {
        //杆太端
        this.platformTooShort();
      }
    }
  }
  //杆太长
  platformTooLong() {
    this.walkTween = this.tweens.add({
      targets: [this.player],
      x: this.pole.x + this.pole.displayHeight + this.player.displayWidth,
      duration: gameOptions.walkTime * this.pole.displayHeight,
      callbackScope: this,
      onComplete: function () {
        //失败
        this.fallAndDie();
      },
    });
  }
  //干太短
  platformTooShort() {
    //杆下落
    this.tweens.add({
      targets: [this.pole],
      angle: 90,
      duration: gameOptions.rotateTime,
      ease: "Cubic.easeIn",
      callbackScope: this,
      onComplete: function () {
        //开始行走
        vm.gameMode = WALKING;
        this.tweens.add({
          targets: [this.player],
          x: this.pole.x + this.pole.displayHeight,
          duration: gameOptions.walkTime * this.pole.displayHeight,
          callbackScope: this,
          onComplete: function () {
            //杆掉落
            this.tweens.add({
              targets: [this.pole],
              angle: 180,
              duration: gameOptions.rotateTime,
              ease: "Cubic.easeIn",
            });
            //失败
            this.fallAndDie();
          },
        });
      },
    });
  }
  //失败
  fallAndDie() {
    vm.gameMode = IDLE;
    //玩家掉落
    this.tweens.add({
      targets: [this.player],
      y: game.config.height + this.player.displayHeight * 2,
      duration: gameOptions.fallTime,
      ease: "Cubic.easeIn",
      callbackScope: this,
      onComplete: function () {
        //震动,重新开始
        this.shakeAndRestart();
        this.sound.add("die").play();
      },
    });
  }
  //开始下一个回合
  prepareNextMove() {
    vm.gameMode = IDLE; //设置空闲状态
    this.platforms[this.mainPlatform].x = game.config.width; //更新主平台位置
    this.mainPlatform = 1 - this.mainPlatform; //更新主平台序号
    this.tweenPlatform(); //移动平台
    this.pole.angle = 0;
    this.pole.x = this.platforms[this.mainPlatform].displayWidth;
    this.pole.displayHeight = gameOptions.poleWidth;
  }
  //震动,重新开始
  shakeAndRestart() {
    // die.play();
    this.cameras.main.shake(800, 0.01);
    this.time.addEvent({
      delay: 2000,
      callbackScope: this,
      callback: function () {
        //游戏结束
        vm.gameEnd();
        this.scene.start("PlayGame");
      },
    });
  }
  //更新,检测碰撞
  update() {
    if (this.player.flipY) {
      let playerBound = this.player.getBounds();
      let coinBound = this.coin.getBounds();
      let platformBound = this.platforms[1 - this.mainPlatform].getBounds();
      if (
        Phaser.Geom.Rectangle.Intersection(playerBound, platformBound).width !=
        0
      ) {
        this.walkTween.stop();
        if (vm.gameMode !=IDLE) this.sound.add("die").play();
        vm.gameMode = IDLE;
        this.shakeAndRestart();
      }
      if (
        this.coin.visible &&
        Phaser.Geom.Rectangle.Intersection(playerBound, coinBound).width != 0
      ) {
        vm.addCoinScore();
        this.sound.add("coin").play();
        this.coin.visible = false;
      }
    }
  }
}

function resize() {
  let canvas = document.querySelector("canvas");
  let windowWidth = window.innerWidth;
  let windowHeight = window.innerHeight;
  let windowRatio = windowWidth / windowHeight;
  let gameRatio = game.config.width / game.config.height;
  if (windowRatio < gameRatio) {
    canvas.style.width = windowWidth + "px";
    canvas.style.height = windowWidth / gameRatio + "px";
  } else {
    canvas.style.width = windowHeight * gameRatio + "px";
    canvas.style.height = windowHeight + "px";
  }
}
</script>

